package util

import common.dto.Quat
import common.dto.RotationAround
import common.dto.Vec3d
import ext.*
import three.js.Group
import three.js.Object3D
import three.js.Quaternion
import three.js.Vector3

object RotationHelper {

    /**
     * Rotates the given [startingPosition] around the arbitrary line ([rotationAround]) and returns the new position
     * and delta rotation.
     *
     * For this, we create a helper three-js group, our `pivot`, and add a child to it. The child is positioned at
     * `startingPosition - rotationAround.origin`. Then, we rotate the pivot around the line direction by the angle
     * of the [rotationAround]. The new position is then the world position of the child. Additionally,
     * the delta rotation is the world quaternion of the helper object (or pivot).
     *
     * @param startingPosition The position that gets rotated.
     * @param rotationAround The line (arbitrary axis) as well as the angle defining the rotation.
     *
     * @return The new position and delta rotation.
     */
    fun applyRotationAround(startingPosition: Vec3d, rotationAround: RotationAround): Pair<Vec3d, Quat> {
        val helperObj = Object3D()
        val pivot = Group().apply { add(helperObj) }
        helperObj.position.set(startingPosition - rotationAround.line.origin)
        pivot.rotateOnAxis(rotationAround.line.direction.asVector3(), rotationAround.angle)
        return Pair(helperObj.getWorldPosition(Vector3()).asVec3d() + rotationAround.line.origin, helperObj.getWorldQuaternion(Quaternion()).asQuat())
    }
}